<template>
  <div class="store">
    <div class="store-top">
      <div class="store-top__title">
        店铺及费用设置
        <div class="store-top__tips">(注意：以下预设置数据用于快速准确计算商品及店铺净利润，数据如有变化请及时更新，避免影响利润计算的准确性及店铺数据化运营)</div>
      </div>
      <div class="store-top__right">备注：限最多创建{{ maxShopLenght }}个店铺</div>
    </div>
    <div class="store-module">
      <div class="store-module-top">
        <div class="store-module-top__btn" @click="newShopBtnClick">新建店铺</div>
      </div>
      <div class="store-module-item" v-for="(array, index) in shopListData" :key="index">
        <div class="store-module-item-top">
          <div class="store-module-item-top__name">店铺名称:</div>
          <el-input
            class="store-module-item__input store-module-item__input--name"
            :class="{'store-module-list--prompt': shopListData[index].isPrompt && (array.name === '' || array.name == null)}"
            size="mini"
            :disabled="!array.isDisable"
            v-model="array.name"></el-input>
        </div>
        <div
          class="store-module-list"
          v-for="item in shopInputModule[index]"
          :key="item.data">
          <div class="store-module-list__name">
            {{ item.name }}:
            <span class="store-module-list__name--star">*</span>
          </div>
          <div
            class="store-module-list-input"
            :class="'store-module-list-input--' + item.type">
            <template v-if="item.type === 'check'">
              <el-checkbox :disabled="!array.isDisable || item.isDisable"
                :value="item.show"
                @change="checkBoxChangeValue(index, !item.show)">暂不提供</el-checkbox>
              <el-checkbox :disabled="!array.isDisable || item.isDisable"
                :value="!item.show"
                @change="checkBoxChangeValue(index, !item.show)">提供</el-checkbox>
              <template v-if="!item.show">
                (&nbsp;
                <el-checkbox
                  v-for="item in item.list"
                  :key="item.data"
                  :disabled="!array.isDisable || item.isDisable"
                  @change="checkBoxSonChangeValue(index, item.data, $event)"
                  v-model="item.show">{{ item.name }}</el-checkbox>
                &nbsp;)
              </template>
            </template>
            <template v-else-if="item.type === 'financial'">
              <div v-for="item in item.list" :key="item.data">
                <el-checkbox
                  :disabled="!array.isDisable || item.isDisable"
                  @change="financialCheckBtnClick(item.data, index, $event)"
                  v-model="item.show">{{ item.name }}</el-checkbox>
                &nbsp;
                <span class="store-module-list-input__link"
                  v-show="item.show && array.isDisable"
                  @click="selectFinancialCountry(item.data, index)">({{ dialogFinancialCountryTitle }})</span>
                <div class="store-module-list-input__line">
                  <template v-for="itemList in item.list">
                    <div
                      class="store-module-list-input__item"
                      :class="{'store-module-list--prompt': shopListData[index].isPrompt && (array.financialFee[itemList.data] === '' || array.financialFee[itemList.data] == null)}"
                      v-if="itemList.show"
                      :key="itemList.data">
                      <div class="store-module-list-input__name">{{ itemList.name }}</div>
                      <el-input
                        size="mini"
                        :disabled="!array.isDisable || itemList.isDisable"
                        prefix-icon="icon-el-inco-cmoney"
                        v-model="array.financialFee[itemList.data]"></el-input>
                    </div>
                  </template>
                </div>
              </div>
              <div class="store-module-list__tips">
                备注：勾选对应的区域后添加已开店的国家(没开店的国家请不要添加或删除),然后在对应的单元格输入该国家实际产生的月均财务费用即可。
                <span class="store-module-list__tips--link" @click="openTextDialog(
                  ' 由于欧盟的税务要求非常严格，通常亚马逊卖家的产品入欧盟成员国的亚马逊仓库并进行销售时都需要申请当地的公司及通过专业的会计师做帐户，年审，报税等。因此每年产生一定的财务费，按月均分将产生该“卖家帐户月均账务费”（备注：英国每3个月一次，1年共4次VAT申报；意大利及戏班牙每季节1次，年度1次，共5次VAT申报；法国每月1次，1年共12次VAT申报；例如财务公司对英国帐户每年收取的做帐户及VAT申报等财务费为￥12000，即卖家帐户月均财务费为￥1000；此项费用通常适用于英国及其它欧盟成员国，美国，加拿大，日本，澳洲等国家通常不涉及此项费用，但视实际情况而定，可按实际录入数据)； ',
                  '更多详情'
                )">更多详情</span>
              </div>
            </template>
            <template v-else>
              <div
                class="store-module-list-input__item"
                :class="{'store-module-list--prompt': shopListData[index].isPrompt && (array[itemList.data] === '' || array[itemList.data] == null)}"
                v-for="itemList in item.list"
                :key="itemList.data">
                <div class="store-module-list-input__name">{{ itemList.name }}</div>
                <template v-if="itemList.type === 'select'">
                  <el-select size="mini" v-model="array[itemList.data]" :disabled="!array.isDisable || itemList.isDisable">
                    <el-option v-for="(s, i) in itemList.array" :key="i" :value="i" :label="s"></el-option>
                  </el-select>
                </template>
                <template v-else-if="itemList.type === 'datePicker'">
                  <el-date-picker :disabled="!array.isDisable || itemList.isDisable" size="mini" v-model="array[itemList.data]"></el-date-picker>
                </template>
                <template v-else>
                  <el-input
                    size="mini"
                    v-model="array[itemList.data]"
                    :disabled="!array.isDisable || itemList.isDisable"
                    :prefix-icon="itemList.preUnit"
                    :suffix-icon="itemList.postUnit"></el-input>
                </template>
              </div>
            </template>
          </div>
          <div class="store-module-list__tips">
            <template v-if="item.data === 'operatingCost'">
              <div class="store-module-list__tips--link" @click="openTextDialog(
                ' 资金运营年息率指您向银行或其它渠道获取资金的成本。按年息对该店铺进行资金运营成本的计算分摊。如为自有资金，此处根据情况可以设置为0； ',
                '温馨提示'
              )">备注</div>
            </template>
            <template v-else-if="item.data === 'collectionDetails'">
              备注：请输入亚马逊最近一期的划款日期，系统将自动为您推算每期的收款日期
            </template>
            <template v-else-if="item.data === 'administrator'">
              备注：如给店管员提供提成，可在"
              <div class="store-module-list__tips--link" @click="goSaleCommissionPage()">商品销售提成设置</div>
              "页面进行预设
            </template>
          </div>
        </div>
        <template v-for="item in shopInputModule[index].managementCommission.list">
          <div class="store-module-list" v-if="item.show" :key="item.data">
            <div class="store-module-list__name">
              {{ item.name }}:
              <span class="store-module-list__name--star">*</span>
            </div>
            <div class="store-module-list-input">
              <div
                class="store-module-list-input__item"
                v-for="itemList in item.list"
                :class="{'store-module-list--prompt': shopListData[index].isPrompt && (array[item.data][itemList.data] === '' || array[item.data][itemList.data] == null)}"
                :key="itemList.data">
                <div class="store-module-list-input__name">{{ itemList.name }}</div>
                <el-input
                  size="mini"
                  v-model="array[item.data][itemList.data]"
                  :disabled="!array.isDisable || itemList.isDisable"
                  :prefix-icon="itemList.preUnit"
                  :suffix-icon="itemList.postUnit"></el-input>
              </div>
            </div>
            <div class="store-module-list__tips">
              <template v-if="item.data === 'commissionForStoreManagement'">
                备注: 如在店管员之上有多店铺运营管理员,可进行此设置
              </template>
              <template v-else-if="item.data === 'accountCommission'">
                备注: 如借用帐户进行多店铺运营并给帐户拥有者收汇管理提成,可进行此设置
              </template>
            </div>
          </div>
        </template>
        <div class="store-module-item-bottom">
          <div class="store-module-item-bottom__btn" v-show="!array.isDisable" @click="changeBtnClick(index)">修改</div>
          <div class="store-module-item-bottom__btn" v-show="array.isDisable" @click="saveBtnClick(index)">保存</div>
          <div class="store-module-item-bottom__btn" v-show="array.type === 'old'" @click="deleteBtnClick(index)">删除</div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogFinancialCountryTitle"
      :visible.sync="dialogFinancialCountryShow"
      :before-close="dialogFinancialCountryClose"
      width="30%">
        <el-checkbox v-for="item in dialogFinancialCountryData" :key="item.data" v-model="item.show" @change="changeFinancialCheck(item.data, item.show)">{{ item.name }}</el-checkbox>
    </el-dialog>
  </div>
</template>

<script>
import {
  ShopSetting, ShopSettingNewModule, financialCountryFatherKey, commissionConfigKey, StoreManagement
} from './class';
import StoreAxios from 'service/store'
import globalData from '../../../../common/globalData';
export default {
  name: 'shopExpenseSettings',
  data() {
    return {
      /**店铺数据 */
      shopData: new ShopSetting(),
      /**店铺输入框模块 */
      shopInputModule: [],
      /**店铺列表数据 */
      shopListData: [],
      maxShopLenght: 5,
      /**国家财务费用弹窗数据 */
      dialogFinancialCountryData: [],
      dialogFinancialCountryIndex: '',
      dialogFinancialCountryName: '',
      dialogFinancialCountryShow: false,
      dialogFinancialCountryTitle: '添加/删除开店国家'
    }
  },
  async created(){
    let res = await StoreAxios.getAll()
    let array = res.data.info
    let obj = {}
    let fCFKeys = Object.keys(financialCountryFatherKey)
    let cCKeys = Object.keys(commissionConfigKey)
    this.shopListData.splice(0, this.shopListData.length)
    this.shopInputModule.splice(0, this.shopInputModule.length)
    array.map(arr => {
      obj = new ShopSetting(false, 'old')
      obj.backendDetailDataParsing(arr)
      let inputModule = globalData.deepClone(ShopSettingNewModule.NEWINPUTMODULE())
      fCFKeys.map(key => {
        if(obj.financialFee[key] !== ''){
          inputModule.financialFee.list[financialCountryFatherKey[key]].show = true
          inputModule.financialFee.list[financialCountryFatherKey[key]].list[key].show = true
        }
      })
      cCKeys.map(key => {
        if(!obj[commissionConfigKey[key]].judgeEmpty()){
          inputModule.managementCommission.list[commissionConfigKey[key]].show = true
        }
      })
      this.shopInputModule.push(inputModule)
      this.shopListData.push(obj)
    })
  },
  methods: {
    /**新建店铺 */
    newShopBtnClick(){
      let length = this.shopListData.length
      if(this.shopListData[0] && this.shopListData[0].type === 'new'){
        this.$message.error('请先将未创建的店铺创建完毕')
        return;
      }
      if(length >= this.maxShopLenght){
        this.$message.error('超过最大数量限制')
        return;
      }
      this.shopListData.unshift(new ShopSetting(true, 'new'))
      this.shopInputModule.unshift(ShopSettingNewModule.NEWINPUTMODULE())
    },
    /**文字提示弹窗 */
    openTextDialog(text, title){
      this.$confirm(text, title)
    },
    /**运营管理多选框改变事件 */
    checkBoxChangeValue(index, bool){
      this.shopInputModule[index].managementCommission.show = bool
      this.shopInputModule[index].managementCommission.list.commissionForStoreManagement.show = !bool
      this.shopInputModule[index].managementCommission.list.accountCommission.show = !bool
    },
    checkBoxSonChangeValue(index, data, bool){
      if(!bool){
        this.shopListData[index][data].clearData()
      }
    },
    /**修改按钮点击事件 */
    changeBtnClick(index){
      let bool = this.shopListData[index].isDisable
      this.shopListData[index].isDisable = !bool
    },
    /**选择显示对应国家的财务费用 */
    selectFinancialCountry(name, index){
      this.dialogFinancialCountryIndex = index
      this.dialogFinancialCountryName = name
      this.dialogFinancialCountryData.splice(0, this.dialogFinancialCountryData.length)
      let obj = this.shopInputModule[index].financialFee.list[name]
      let keys = Object.keys(obj.list)
      keys.map(key => this.dialogFinancialCountryData.push(obj.list[key]))
      this.dialogFinancialCountryShow = true
    },
    changeFinancialCheck(data, bool){
      if(!bool){
        this.shopListData[this.dialogFinancialCountryIndex].financialFee[data] = ''
      }
    },
    financialCheckBtnClick(name, index, bool){
      if(bool){
        this.selectFinancialCountry(name, index)
      }else{
        let obj = this.shopInputModule[index].financialFee.list[name].list
        let keys = Object.keys(obj)
        keys.map(key => {
          this.shopListData[index].financialFee[key] = ''
          obj[key].show = false
        })
      }
    },
    /**国家财务弹窗关闭事件 */
    dialogFinancialCountryClose(){
      let bool = this.dialogFinancialCountryData.every(obj => !obj.show)
      this.shopInputModule[this.dialogFinancialCountryIndex].financialFee.list[this.dialogFinancialCountryName].show = !bool
      this.dialogFinancialCountryShow = false
    },
    /**判断数据是否填写完毕 */
    judgeDataFinish(index){
      let keys = Object.keys(this.shopListData[index])
      let financialObject = this.shopInputModule[index].financialFee.list
      let financialAreaKeys = Object.keys(financialObject)
      let financialSonKeys = []
      let financialKeys = []
      let managementCommissionKeys = Object.keys(StoreManagement)
      financialAreaKeys.map(key => {
        financialSonKeys = Object.keys(financialObject[key].list)
        financialSonKeys.map(sonKey => {
          if(financialObject[key].list[sonKey].show) financialKeys.push(sonKey)
        })
      })
      if(this.shopListData[index].name === '' || this.shopListData[index].name == null){
        return false
      }
      for(let key of keys){
        if(key == 'isDisable' || key == 'isPrompt'){
          continue
        }
        if(this.shopListData[index][key] === '' || this.shopListData[index][key] == null){
          return false
        }
      }
      /**财务费 */
      for(let financialKey of financialKeys){
        if(this.shopListData[index].financialFee[financialKey] === '' || this.shopListData[index].financialFee[financialKey] == null){
          return false
        }
      }
      /**运营管理提成 */
      if(this.shopInputModule[index].managementCommission.list.accountCommission){
        managementCommissionKeys.map(key => {
          if(this.shopListData[index].accountCommission[key] === '' || this.shopListData[index].accountCommission[key] == null){
            return false
          }
        })
      }
      if(this.shopInputModule[index].managementCommission.list.commissionForStoreManagement){
        managementCommissionKeys.map(key => {
          if(this.shopListData[index].commissionForStoreManagement[key] === '' || this.shopListData[index].commissionForStoreManagement[key] == null){
            return false
          }
        })
      }
      return true
    },
    /**保存按钮点击事件 */
    async saveBtnClick(index){
      let obj = {
        new: (index) => {
          return StoreAxios.add(this.shopListData[index].getAddStoreAxiosBody)
        },
        old: (index) => {
          return StoreAxios.updata(this.shopListData[index].getUpdataStoreAxiosBody)
        }
      }
      if(!this.judgeDataFinish(index)){
        this.$message.error('请将数据补充完整')
        this.shopListData[index].isPrompt = true
        return;
      }
      let res = await obj[this.shopListData[index].type](index)
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      if(index == 0){
        this.shopListData[index].type = 'old'
      }
      this.shopListData[index].isDisable = false
      this.$message.success(res.data.info)
    },
    /**删除按钮点击事件 */
    async deleteBtnClick(index){
      let data = {
        id: this.shopListData[index].id
      }
      let res = await StoreAxios.deleteStore(data)
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      this.$message.success('删除成功')
      this.shopListData.splice(index, 1)
      this.shopInputModule.splice(index, 1)
    },
    /**页面切换 */
    goSaleCommissionPage(){
      this.$emit('go', {
        id: 'salesCommissionSetting',
        name: '商品销售提成设置',
      })
    }
  },
  computed:{
    managementCommissionShow(){
      let arr = this.shopInputModule.map(obj => {
        return{
          commissionForStoreManagement: obj.managementCommission.list.commissionForStoreManagement.show,
          accountCommission: obj.managementCommission.list.accountCommission.show,
        }
      })
      return JSON.stringify(arr)
    }
  },
  watch: {
    managementCommissionShow: {
      immediate: true,
      handler(newVal){
        let arr = JSON.parse(newVal)
        arr.map((obj, index) => {
          this.shopInputModule[index].managementCommission.show = Object.keys(obj).every(key => !obj[key])
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.store{
  width: 1800px;
  min-height: 700px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: end;
    font-weight: bold;
    margin: 6px 14px;
    padding: 4px 6px;
    border-bottom: 1px solid #d7d7d7;
    &__title{
      font-size: 18px;
      color: black;
      display: flex;
      align-items: end;
    }
    &__tips{
      font-size: 12px;
      font-weight: normal;
      color: #fca605;
    }
    &__right{
      font-size: 14px;
      color: #fca605;
    }
  }
  &-module{
    margin: 0 30px;
    position: relative;
    &-top{
      position: absolute;
      right: 0;
      display: flex;
      justify-content: end;
      align-items: center;
      &__btn{
        background-color: #409EFF;
        color: white;
        padding: 10px 25px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &-item{
      padding: 10px 0 5px;
      & + &{
        border-top: #00a0c7 1px dotted;
      }
      &-top{
        font-weight: bolder;
        color: #409EFF;
        font-size: 14px;
        display: flex;
        align-items: center;
        &__name{
          width: 100px;
        }
      }
      &__input{
        &--name{
          width: 200px;
        }
      }
      &-bottom{
        display: flex;
        justify-content: end;
        &__btn{
          font-size: 14px;
          padding: 5px 15px;
          background: #409EFF;
          color: white;
          margin-left: 10px;
          &:hover{
            cursor: pointer;
            opacity: .8;
          }
        }
      }
    }
    &-list{
      margin: 10px 30px 30px;
      display: flex;
      align-items: center;
      &__name{
        width: 200px;
        &--star{
          color: red;
        }
      }
      &__tips{
        color: #409EFF;
        display: flex;
        &--link{
          text-decoration: underline;
          font-weight: bold;
          &:hover{
            cursor: pointer;
            opacity: .8;
          }
        }
      }
      &-input{
        display: flex;
        ::v-deep{
          .el-input__inner{
            width: 150px;
          }
          .el-date-editor{
            width: 150px;
          }
          .icon-baifenbi{
            font-size: 14px;
          }
          .icon-meiyuan_o{
            font-size: 14px;
            color: #00a0c7;
          }
        }
        &--financial{
          flex-direction: column;
        }
        &__link{
          font-size: 10px;
          color: #409EFF;
          text-decoration: underline;
          &:hover{
            cursor: pointer;
            opacity: .8;
          }
        }
        &__line{
          display: flex;
          margin: 20px 0 10px;
          ::v-deep{
            .el-input__inner{
              width: 90px;
            }
          }
        }
        &__item{
          position: relative;
          margin-right: 10px;
        }
        &__name{
          position: absolute;
          bottom: 110%;
          width: 100%;
          text-align: center;
        }
      }
      &--prompt{
        ::v-deep{
          .el-input__inner{
            border-color: red;
          }
        }
      }
    }
  }
}
</style>
